import getEmployeeId from "utils/commonAdmin";
import requests from "./httpService";

const FranchisePageServices = {
  getAllFranchisePage: async (tab = "") => {
    return requests.post(`/franchise/`, tab);
  },
  getAllFranchiseList: async () => {
    return requests.get(`/franchise/`);
  },

  addfranchisePage: async (body) => {
    return requests.post(`/franchise/add`, body);
  },
  getFranchisePageById: async (id) => {
    return requests.get(`/franchise/${id}`);
  },

  updateFranchisePage: async (id, body) => {
    return requests.put(`/franchise/update/${id}`, body);
  },

  deleteFranchise: async (id) => {
    return requests.delete(`/franchise/${id}`);
  },
  updateFranchiseStatus: async (id, data) => {
    return requests.put(`/franchise/account-status/${id}`, data);
  },

  updateFranchiseApprove: async (id, data) => {
    return requests.put(`/franchise/approve/${id}`);
  },
  updateFranchiseReject: async (id, data) => {
    return requests.put(`/franchise/reject/${id}`, data);
  },

  //franchise allotment api services
   getFranchiseAllotmentListoption: async (id) => {
      return requests.get(`franchiseAllotment/franchise-names/${id}`);
    },
      getFranchiseAllotmentListoptionwithoutId: async () => {
      return requests.get(`franchiseAllotment/franchise-names/`);
    },
  getFranchiseAllotmentList: async (data) => {
    return requests.post(`franchiseAllotment/list`,data);
  },
  allotFranchise: async (data) => {
    return requests.put(`franchiseAllotment/allot`, data);
  },
    modifyAllotFranchise: async (data) => {
    return requests.put(`franchiseAllotment/modify`, data);
  },
  getServiceStatebyVendor: async (franchise_id) => {
    return requests.get(`franchiseAllotment/service-areas/${franchise_id}`)
  },
 
};

export default FranchisePageServices;
